import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import Image from "../images/Image";
import InputLabel from "../inputfields/InputLabel";
import InputShimmer from "../inputfields/InputShimmer";

dayjs.extend(customParseFormat);

interface CustomDatePickerProps {
  testID: string;
  label: string;
  handleStates: (date: dayjs.Dayjs | null, type: string) => void;
  value: dayjs.Dayjs | null;
  error?: string;
  disabled: boolean;
  type: "dob" | string;
  disabledDate?: boolean;
  fieldError?: boolean;
  divClassName?: string;
  id?: string;
  required: boolean;
  classType?: string;
  editLoading?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  testID,
  label,
  handleStates,
  divClassName,
  fieldError,
  value,
  error,
  disabled,
  id,
  type,
  disabledDate,
  required,
  classType,
  editLoading
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const getDisabledDate = (current: dayjs.Dayjs) => {
    return current && current > dayjs(); // Example: Disable future dates
  };

  return (
    <div className={divClassName}>
      <InputLabel labelName={label} id={id || 'date_label'} required={required} />
      {editLoading ? (<InputShimmer />) :
        <DatePicker
          disabled={disabled}
          className={` ${disabled
            ? `custom-datepicker-disabled${classType ? `-${classType}` : ""}`
            : (error || fieldError)
              ? `custom-datepicker-error${classType ? `-${classType}` : ""}`
              : `custom-datepicker${classType ? `-${classType}` : ""}`
            } w-full py-4 pl-4 pr-4 !shadow-none focus:!shadow-none focus-within:!border-2 h-14 focus-within:!px-[15px] `}
          autoComplete="off"
          data-testid={testID ||id}
          placeholder={'Select Date'}
          format={"DD MMM YYYY"}
          value={value}
          suffixIcon={<Image src="calendar" />}
          disabledDate={type === "dob" || disabledDate ? getDisabledDate : undefined}
          onChange={(date) => handleStates(date, type)}
          onClick={() => setIsFocused(true)}
          getPopupContainer={(trigger) => trigger.parentElement || document.body}
        />
      }
      {error && (
        <ErrorMessage errorMessage={error || ''} />
      )}
    </div>
  );
};

export default CustomDatePicker;